



















import Vue from 'vue'
import user from '@/assets/svg/rounded/user.svg?inline'
import add from '@/assets/svg/rounded/add.svg?inline'
import remove from '@/assets/svg/rounded/remove.svg?inline'

interface Props {
  title: string
  count: number
  min: number
  disable: boolean
}

interface Methods {
  setCount: (value: number) => void
}

interface Computed {
  model: number | string
  disablePrev: boolean
}

export default Vue.extend<{}, Methods, Computed, Props>({
  components: {
    user,
    add,
    remove,
  },
  props: {
    title: {
      required: true,
    },
    count: {
      required: true,
    },
    min: {
      required: true,
    },
    disable: {
      required: true,
    },
  },
  methods: {
    setCount(value) {
      this.model = Number(this.model) + value
    },
  },
  computed: {
    model: {
      get() {
        return this.count
      },
      set(value) {
        return this.$emit('input', value)
      },
    },
    disablePrev() {
      return this.count <= this.min || this.disable
    },
  },
})
